import React, {Component} from "react";
import {ServerSidePaginationTable, TableButtonsBuilder} from "../../../components/Letflow/Table";
import {request} from "../../../api-client";
import {makeUrlWithTableParams, validateEmail} from "../../../utils";
import localization from "../../../config/localization";
import TableSubcomponent from "./TableSubcomponent";
import TableButton from "../../../components/Letflow/Table/Buttons/TableButton";
import {Visibility} from "@material-ui/icons";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel, Radio,
  RadioGroup, Tooltip
} from "@material-ui/core";
import {Link} from "react-router-dom";
import TagSelection from "../../../components/Letflow/TagSelection/TagSelection";
import queryString from "querystring";
import {makeImageUrlWithSize} from "../../../layouts/Home/HomeElements/utils";
import Person from "@material-ui/icons/Person";

class Table extends Component {
  state = {
    total: "",
    openIntegrateDialog: false,
    contentCreatorId: '',
    contentCreatorType: '',
    types: [],
    showTagSelection: false,
    containerType: 'all',
    showTagDialog: false,
    tagGroups: [],
    selectedTags: [],
    unselectedTags: [],
    loaded: false,
    hasUser: "all"
  };

  componentDidMount() {
    this.requestContentCreatorTypes()
      .then(() => {
        let queryParams = queryString.parse(this.props.location.search)['?table_params']
        if (queryParams && JSON.parse(queryParams).filtered.length > 0 && JSON.parse(queryParams).filtered[0].id === 'content_creator_type_id') {
          this.setState({
            selectedTags: eval(localStorage.getItem("selectedTags")) ? JSON.parse(eval(localStorage.getItem("selectedTags"))) : [],
            unselectedTags: eval(localStorage.getItem("unselectedTags")) ? JSON.parse(eval(localStorage.getItem("unselectedTags"))) : [],
            showTagSelection: true,
            selectedType: this.state.types.find(type => type.id == JSON.parse(queryParams).filtered[0].value),
          }, () => {
            this.paintAllTags().then(() => this.setState({loaded: true}))
          })
        } else {
          this.setState({loaded: true})
        }
      })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.requestContentCreatorTypes().then(() => this.refs.table.forceUpdate())
    }
  }

  requestContentCreatorTypes = () => {
    const filter = {filterBy: []}
    filter.filterBy.push({
      column: "type",
      filter:  this.props.isTalent ? 'talent' : this.props.isAudiovisual ? 'audiovisual' : 'editorial'
    },
    {
      column: "dashboard_combos",
      filter: true
    });
    return request.contentCreatorType.getAll(filter)
      .then(contentCreatorTypes => {
        const types = contentCreatorTypes.map(contentCreatorType => ({id: contentCreatorType.id, label: contentCreatorType.name, slug: contentCreatorType.slug}))
        this.setState({types})
      })
  }

  handleAlertClosed = artistId => status => {
    if (status === "passed") this.refs.table.removeById(artistId);
  };

  buttons = contentCreator => {
    const {id, name, email, type, user} = contentCreator;

    let editUrl = '';
   if (this.props.isTalent) {
      editUrl = makeUrlWithTableParams(`/panel/talents/content_creators/${id}/edit`);
    } else if (this.props.isAudiovisual) {
      editUrl = makeUrlWithTableParams(`/panel/audiovisual/content_creators/${id}/edit`);
    } else {
      editUrl = makeUrlWithTableParams(`/panel/editorial/content_creators/${id}/edit`);
    }

    const buttonBuilder = new TableButtonsBuilder();

    if(user) {
      buttonBuilder.withOther(
        <TableButton
          title={localization.get('button.see_user')}
          onClick={() => window.open(`${window.location.origin}/panel/users/${user.id}/edit` , "_blank")}>
          <Person/>
        </TableButton>)
    }

    if(this.props.isTalent && validateEmail(email)) {
      buttonBuilder.withNotify(name, () => request.contentCreator.notify(id, 1),  () => {}, "tooltip.notify_one")
    }

   buttonBuilder.withShare('contentCreator', id, `${window.location.protocol}//${window.location.hostname}/public/content_creators/`)

    buttonBuilder.withOther(
      <TableButton
        title={localization.get('button.see_home')}
        onClick={() => window.open(`${window.location.origin}/preview/content_creators/${contentCreator.hashcode}` , "_blank")}
      ><Visibility/></TableButton>)
    buttonBuilder.withEdit(editUrl);
    buttonBuilder.withDelete(
      name,
      () => request.contentCreator.delete(id),
      this.handleAlertClosed(id)
    );

    return buttonBuilder.build();
  };

  clearAllTags = () =>
    new Promise(resolve => {
      this.setState( {tagGroups: this.state.tagGroups.map(tagGroup => {
          return {...tagGroup,
            tags: tagGroup.tags.map(tag => {
              return {...tag, state: 'available'}
            })
          }
        })
      })
      resolve()
    }).then(() => this.setState({selectedTags: [], unselectedTags: []}))

  setTagGroups = tagGroups => this.setState(state => ({...state, tagGroups}))

  updateTagColor = (selectedTag, value) =>
    this.setState( {tagGroups: this.state.tagGroups.map(tagGroup => {
          return {...tagGroup,
            tags: tagGroup.tags.map(tag => {
              if (tag.id === selectedTag) {
                return {...tag, state: value}
              }
              return tag
            })
          }
        }
      )
    })

  paintAllTags = () =>
    new Promise(resolve => {
      this.state.selectedTags.map(tag => this.updateTagColor(tag, "selected"))
      this.state.unselectedTags.map(tag => this.updateTagColor(tag, "unselected"))
      resolve()
    })

  onSelectedTagsChanged = selectedTag => {
    if (this.state.selectedTags.includes(selectedTag)) { //Remove from selected / add to unselected tags
      this.state.unselectedTags.push(selectedTag)
      this.setState({
        selectedTags: this.state.selectedTags.filter(tags => tags !== selectedTag),
        unselectedTags: this.state.unselectedTags
      }, () => this.updateTagColor(selectedTag, "unselected"))
    } else if(this.state.unselectedTags.includes(selectedTag)) { //Remove from unselected / add to available tags
      this.setState({
        unselectedTags: this.state.unselectedTags.filter(tags => tags !== selectedTag),
      }, () => this.updateTagColor(selectedTag, "available"))
    } else { //Remove from available / add to selected tags
      this.state.selectedTags.push(selectedTag);
      this.setState({selectedTags: this.state.selectedTags}, () => this.updateTagColor(selectedTag, "selected"))
    }
  };

  makeTagSelectionDialog = () =>
    <Dialog open={this.state.showTagDialog} onClose={() => this.setState({showTagDialog: false})} onBackdropClick={() => this.setState({showTagDialog: false})}>
      <DialogContent style={{textAlign: "center"}}>
        <TagSelection
          homeElementTagSelection={true}
          allowUnselected={true}
          data={this.state.tagGroups}
          onSelectedTagsChanged={this.onSelectedTagsChanged}
          clearAllTags={this.clearAllTags}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => {
          localStorage.setItem("selectedTags", `"[${this.state.selectedTags}]"`)
          localStorage.setItem("unselectedTags", `"[${this.state.unselectedTags}]"`)
          this.refs.table.forceUpdate();
          this.setState({showTagDialog: false})
        }}>
          {localization.get('home_editor.tag_selection.filter')}
        </Button>
      </DialogActions>
    </Dialog>


  columns = () => [
    {
      id: "image",
      accessor: contentCreator => (
        <img
          alt="ContentCreator"
          src={makeImageUrlWithSize(contentCreator, 'xs')}
          width={50}
          height={50}
        />
      ),
      style: {
        float: "left"
      },
      resizeable: false,
      sortable: false,
      filterable: false,
      width: 60
    },
    {
      Header: localization.get("table.name"),
      accessor: "name",
      Filter: ({filter, onChange}) => (
        <input
          onChange={event => onChange(event.target.value)}
          value={filter ? filter.value : ""}
          placeholder={localization.get("table.search")}
        />
      )
    },
    {
      Header: localization.get("category"),
      id: "content_creator_type_id",
      accessor: content => content.type ? content.type.name : "",
      Filter: ({ filter, onChange }) => (
        <select
          style={{ width: "100%" }}
          onChange={event => {
            onChange(event.target.value)
            localStorage.setItem("selectedTags", `"[]"`)
            localStorage.setItem("unselectedTags", `"[]"`)
            this.setState({
              showTagSelection: !!event.target.value,
              selectedType: this.state.types.find(type => type.id == event.target.value),
              selectedTags: [],
              unselectedTags: [],
            })
          }}
          value={filter ? filter.value : ""}
        >
          <option value="" selected />
          {this.state.types.sort((a, b) => a.label.localeCompare(b.label)).map(type => {
            return <option value={type.id}>{localization.get(type.label)}</option>;
          })}
        </select>
      ),
      sortable: false
    },
    {

      Header: !this.props.isTalent ? localization.get("form.status") : localization.get("table.active"),
      id:  "active",
      accessor: contentCreator => contentCreator.active ? localization.get('table.active') : (!!contentCreator.release_date ? localization.get('table.programed') : localization.get('table.inactive')),
      filterable: true,
      Filter: ({filter, onChange}) => (
        <select
          style={{width: "100%"}}
          onChange={event => onChange(event.target.value)}
          value={filter ? filter.value : ""}
        >
          <option value="" selected/>
          <option value={1}>{localization.get('table.active')}</option>
          <option value={0}>{localization.get('table.inactive')}</option>
        </select>
      ),
      sortable: false,
      style: { textAlign: 'center' },
      width: 120
    },
    {
      Header: localization.get("table.weight"),
      id: "weight",
      filterable: false,
      accessor: contentCreator => contentCreator.weight,
      sortable: true,
      style: { textAlign: 'center' },
      width: 120
    },
    {
      id: "actions",
      Header: localization.get("table.actions"),
      sortable: false,
      filterable: false,
      accessor: this.buttons,
      width: 220,
      Footer: <span style={{float: "right", fontSize: "18px", marginTop: "15px"}}><strong>Total: </strong>{this.state.total}</span>
    }
  ];

  makeSubComponent = row => (
    <TableSubcomponent {...this.props} contentCreator={row.original}/>
  );

  render = () => {
    return (
      <div>
        {this.makeTagSelectionDialog()}
            <div>
              {this.props.isTalent &&
                <>
                  <FormControl style={{float: "left", position: "relative"}}>
                    <RadioGroup
                      name="hasUser"
                      value={this.state.hasUser}
                      onChange={event => {
                        this.setState({hasUser: event.target.value})
                        this.refs.table.forceUpdate();
                      }}
                      style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
                    >
                      <FormControlLabel style={{width: "fit-content", float: "left", position: "relative"}} value="all" control={<Radio color="default"/>} label={localization.get('clients.all')} />
                      <FormControlLabel style={{width: "fit-content", float: "left", position: "relative"}} value="user" control={<Radio color="default"/>} label={localization.get('clients.with_user')}/>
                      <FormControlLabel style={{width: "fit-content", float: "left", position: "relative"}} value="not_user" control={<Radio color="default"/>} label={localization.get('clients.without_user')}/>
                    </RadioGroup>
                  </FormControl>
                  <FormControl style={{float: "left", position: "relative"}}>
                    <RadioGroup
                      name="type"
                      value={this.state.containerType}
                      onChange={event => {
                        this.setState({containerType: event.target.value})
                        this.refs.table.forceUpdate();
                      }}
                      style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
                    >
                      <FormControlLabel style={{width: "fit-content", float: "left", position: "relative"}} value="all"
                                        control={<Radio color="default"/>} label={localization.get('clients.all')}/>
                      <FormControlLabel style={{width: "fit-content", float: "left", position: "relative"}}
                                        value="bloomclouds" control={<Radio color="default"/>} label={"Creators"}/>
                      <FormControlLabel style={{width: "fit-content", float: "left", position: "relative"}}
                                        value="bigCreator" control={<Radio color="default"/>} label={"Big Creators"}/>
                    </RadioGroup>
                  </FormControl>
              </>
            }
            <Tooltip title={localization.get(!this.state.showTagSelection ? 'filter_tags.disabled' : "home_editor.tag_selection.filter")} placement='top'>
              <div style={{display: "inline-block"}}>
              <Button
                disabled={!this.state.showTagSelection}
                style={{marginTop: 7}}
                onClick={() => {
                  request.tagGroup.getAll({filterBy: [{ column: 'type', filter: this.state.selectedType.slug}, { column: 'creation_group', filter: '0'}]})
                    .then(tags => this.setTagGroups(tags))
                    .then(() => this.paintAllTags())
                    .then(() => this.setState({showTagDialog: true}))
                }}
              >
                {localization.get('filter_tags')}
              </Button>
              </div>
            </Tooltip>

            {(this.props.isTalent || this.props.isAudiovisual) &&
              <Link style={{marginRight: 10, marginTop: 15, float: "right", position: "relative"}} to={this.props.isTalent ? '/panel/talents/content_creations' :'/panel/audiovisual/content_creations' }>
                <span>{localization.get("content_creators.view_materials")}</span>
              </Link>
            }
          </div>

        {this.state.loaded &&
        <div style={{ width: "100%", float: "left", position: "relative" }}>
          <ServerSidePaginationTable
            ref="table"
            columns={this.columns()}
            requestTableData={paginationConfig => {
              paginationConfig = { ...paginationConfig, filterBy: paginationConfig.filterBy.concat([{ column: 'type', filter: this.props.isTalent ? 'talent' : this.props.isAudiovisual ? 'audiovisual' : 'editorial'  }])}

              if (this.state.hasUser !== 'all') {
                paginationConfig = { ...paginationConfig, filterBy: paginationConfig.filterBy.concat([{ column: 'has_user', filter: this.state.hasUser }]) };
              }

              if (this.state.containerType !== 'all') {
                paginationConfig = { ...paginationConfig, filterBy: paginationConfig.filterBy.concat([{ column: 'brand', filter: this.state.containerType }]) };
              }

              if (this.state.selectedTags.length > 0) {
                paginationConfig = { ...paginationConfig, filterBy: paginationConfig.filterBy.concat([{ column: 'tags_ids', filter: [...this.state.selectedTags] }]) };
              }
              if (this.state.unselectedTags.length > 0) {
                paginationConfig = { ...paginationConfig, filterBy: paginationConfig.filterBy.concat([{ column: 'not_tags_ids', filter: [...this.state.unselectedTags] }]) };
              }

              return request.contentCreator.getAll(paginationConfig).then(response => {
                this.setState({total: response.meta.total});
                return response;
              });
            }}
            subComponent={this.makeSubComponent}
          />
        </div>
        }
      </div>
    );
  };
}

export default Table;
